import React from 'react';
import useServicesPerYearDonutChart from './hooks/useServicesPerYearDonutChart';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';

export const ServicesPerYearDonut = ({ height }) => {
    const { module } = useServicesChartsDataContext();
    const { series, subtitles } = useServicesPerYearDonutChart();

    return (
        <Donut
            labelsOutside
            height={height}
            title={`Distribuição ${module.sectionTitle} no Período`}
            series={series}
            subtitles={subtitles}
            chartData={[]}
            isMoney
        />
    );
};
